module.exports = __webpack_public_path__ + "static/media/55_000064.51d5067d.jpg";